import {assert} from 'assert-ts';
import type {DataValue, Part} from 'schemaDefinition/types';

export const mapValueGetter = (part: Part, value: DataValue) => {
  assert(!Array.isArray(part), 'mapValueGetter: part is array');

  /**
   * Date values can only be one value.
   */
  const firstDateValue = Array.isArray(value) ? value?.[0] : value;

  switch (part.type) {
    case 'date':
      if (typeof firstDateValue === 'number') {
        return new Date(firstDateValue);
      }
      if (typeof firstDateValue === 'string') {
        const test = new Date(firstDateValue);
        if (test.toString() !== 'Invalid Date') {
          return test;
        }
        // YYYY-MM-DD
        if (firstDateValue.length === 10) {
          const [year, month, day] = firstDateValue.split('-');
          const nYear = Number(year);
          const nMonth = Number(month);
          const nDay = Number(day);

          if (
            !isNaN(nYear) &&
            nYear > 0 &&
            !isNaN(nMonth) &&
            nMonth > 0 &&
            !isNaN(nDay) &&
            nDay > 0
          ) {
            return new Date(Number(year), Number(month) - 1, Number(day));
          }
        }
      }

      return undefined;
    case 'year':
      return Array.isArray(value) ? value.map(Number) : Number(value);
    default:
      return value;
  }
};
